var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6265 26.0001C22.1303 27.1868 21.1867 28.1304 20 28.6266C18.8133 28.1304 17.8697 27.1868 17.3735 26.0001H19.0685C19.313 26.3668 19.6287 26.6841 20 26.9323C20.3713 26.6848 20.687 26.3668 20.9323 26.0001H22.6265ZM24.5 22.1038L26 23.8048V25.2501H14V23.8048L15.5 22.1038V17.7501C15.5 15.1378 17.378 12.9148 20 12.0913C22.622 12.9148 24.5 15.1378 24.5 17.7501V22.1038ZM23.9525 23.7501L23 22.6701V17.7501C23 16.0116 21.8225 14.4276 20 13.6851C18.1775 14.4276 17 16.0108 17 17.7501V22.6701L16.0475 23.7501H23.9525ZM20 19.2501C19.6022 19.2501 19.2206 19.092 18.9393 18.8107C18.658 18.5294 18.5 18.1479 18.5 17.7501C18.5 17.3522 18.658 16.9707 18.9393 16.6894C19.2206 16.4081 19.6022 16.2501 20 16.2501C20.3978 16.2501 20.7794 16.4081 21.0607 16.6894C21.342 16.9707 21.5 17.3522 21.5 17.7501C21.5 18.1479 21.342 18.5294 21.0607 18.8107C20.7794 19.092 20.3978 19.2501 20 19.2501Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/Icon1_4.db95c468a99fa369c6919f0d960b5b8d.svg";
export { ForwardRef as ReactComponent };